// В записи матча заголовок главы лежит целиком («Глава 2» — chapter.shortTitle
// из configs/tutorial), а в плашке истории места мало: справа он делит строку
// с датой и никнеймом. Сокращаем при показе, а не в базе — старые записи уже
// сохранены в полном виде, и переписывать их ради вида не за чем
const CHAPTER_WORD_PATTERN = /^Глава\s+/i;

/**
 * «Глава 2» -> «Гл. 2». Заголовок неожиданного вида возвращается как есть.
 *
 * @param {string} chapterTitle
 * @returns {string}
 */
export const formatTutorialChapterShortTitle = (chapterTitle) => {
  const title = String(chapterTitle ?? '').trim();
  if (!CHAPTER_WORD_PATTERN.test(title)) {
    return title;
  }
  return title.replace(CHAPTER_WORD_PATTERN, 'Гл. ');
};
